// extracted by mini-css-extract-plugin
module.exports = {"SlideWrapper":"BannerSliderItem_SlideWrapper__HxIPK"};